import React from 'react'
import Script from 'next/script'
import '@lib/firebase'

const isProduction = process.env.NODE_ENV === 'production'

const GoogleAnalytics = () => {
    if (!isProduction) return null
    return (
        <>
            <Script
                strategy="lazyOnload"
                async={true}
                crossOrigin={'anonymous'}
                src={`https://www.googletagmanager.com/gtag/js?id=${process.env.NEXT_PUBLIC_GOOGLE_MEASUREMENT_ID}`}
            />

            <Script id="" strategy="lazyOnload" crossOrigin={'anonymous'} async={true}>
                {`
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
              gtag('config', '${process.env.NEXT_PUBLIC_GOOGLE_MEASUREMENT_ID}', {
              page_path: window.location.pathname,
              });
          `}
            </Script>
        </>
    )
}
export default GoogleAnalytics
